import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCocoapodsComponent } from './simple-icons-cocoapods.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCocoapodsComponent ],
    exports:      [ SimpleIconsCocoapodsComponent ],
    bootstrap:    []
})
export class SimpleIconsCocoapodsModule {}
